module.exports = __webpack_public_path__ + "static/ls-website-sc-1f5648bf4b643746ac2d86aca7a444da.png";